export default __webpack_public_path__ + "static/media/sidebar-background.840ed45f.svg";